function initProjectFilters() {
    document.querySelectorAll('[data-project-filter]').forEach(filter => {
        const projects = [];
        let current = null;
        for (let node = filter.nextElementSibling; node; node = node.nextElementSibling) {
            if (node.matches('.text_media[data-project-topline]')) {
                current = { element: node, topline: node.dataset.projectTopline.trim(), spacers: [] };
                projects.push(current);
            } else if (node.matches('.spacing')) {
                if (current) current.spacers.push(node);
            } else {
                break;
            }
        }
        if (!projects.length) return;
        const nav = filter.querySelector('nav');
        const status = filter.querySelector('[role="status"]');
        const terms = [...new Set(projects.map(project => project.topline).filter(Boolean))];
        const buttons = [];
        const select = term => {
            let count = 0;
            projects.forEach(project => {
                const visible = term === null || project.topline === term;
                project.element.hidden = !visible;
                project.spacers.forEach(spacer => { spacer.hidden = !visible; });
                if (visible) count++;
            });
            buttons.forEach(({ button, value }) => button.setAttribute('aria-pressed', String(value === term)));
            status.textContent = `${count} ${count === 1 ? 'Projekt' : 'Projekte'} angezeigt`;
            window.ScrollTrigger?.refresh();
        };
        [null, ...terms].forEach(term => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'project_filter_button button button--bracket';
            button.setAttribute('aria-pressed', String(term === null));
            ['[', term === null ? 'Alle' : term, ']'].forEach((text, index) => {
                const span = document.createElement('span');
                span.className = index === 1 ? 'button_text' : `bracket bracket--${index === 0 ? 'left' : 'right'}`;
                if (index !== 1) span.setAttribute('aria-hidden', 'true');
                span.textContent = text;
                button.append(span);
            });
            button.addEventListener('click', () => select(term));
            nav.append(button);
            buttons.push({ button, value: term });
        });
        filter.hidden = false;
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProjectFilters);
} else {
    initProjectFilters();
}
